// @flow

export function renameKeys<O: {}>(obj: O, newKeys: { [key: $Keys<O>]: string }) {
  return Object.keys(obj).reduce((acc, key) => {
    const newKey = newKeys[key] || key;
    return { ...acc, [newKey]: obj[key] };
  }, {});
}

export default renameKeys;



// WEBPACK FOOTER //
// ./src/common/utils/renameKeys.js